<!-- check box -->
<div class="boolean-indicator">
  <input
    type="checkbox"
    [checked]="value === true || value === 'Y'"
    [disabled]="true"
  />
</div>
